<script lang="ts">

    import type { Event } from "../scripts/event";
    import { storeLanguage, lang_fr } from "../scripts/store";

    export let props: Event;

    function formatDate(inDate: string) {
        const an = inDate.substring(0, 4);
        const mois = inDate.substring(5,7);
        const jour = inDate.substring(8, 10);
        const returnValue = jour+"/"+mois+"/"+an;
        return returnValue;
    }
</script>

<style lang="scss">

	.tileevent {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 90%;
        margin: 100px 0 100px 0;
        &__title {
            align-self: flex-start;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: flex-start;
        }
        &__img {
            width: 100%;
            padding: 45px 15px 15px 15px;
        }
	}

    @include large {
        .tileevent {
            width: 100%;
            &__img {
                width: 100%;
                cursor: pointer;
            }
        }
    }

</style>

<div class="tileevent">
    <div class="tileevent__title">
        <div class="font__h2">
            {#if ($storeLanguage == $lang_fr)}
            {props.title_fr}
            {:else}
            {props.title_en}
            {/if}
        </div>
        <div class="font__h4">
            {#if ($storeLanguage == $lang_fr)}
            Le {formatDate(props.date_event)}
            {:else}
            The {formatDate(props.date_event)}
            {/if}
        </div>
    </div>
    <a href={props.url} target="_blank">
        {#if ($storeLanguage == $lang_fr)}
        <img class="tileevent__img" title={props.title_fr} alt={props.title_fr} src="../assets/images/events/{props.id}_{props.flyer}">
        {:else}
        <img class="tileevent__img" title={props.title_en} alt={props.title_en} src="../assets/images/events/{props.id}_{props.flyer}">
        {/if}
    </a>
</div>
